module.exports = __webpack_public_path__ + "assets/btn_quick_use_default.1db46112.svg";